import React, { useEffect, useState } from 'react';
import logoIcon from '../../Images/favicon.png'; // Updated main logo
import favIcon from '../../Images/favicon.png';
import avatarIcon from '../../Images/avatar1.jpg';
import { Link, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreaters } from '../../Redux';
import { FaSun, FaMoon, FaCloudSun, FaHandPaper, FaStethoscope } from 'react-icons/fa';

export default function Sidebar() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userActions = bindActionCreators(actionCreaters, dispatch);

    const [showWelcome, setShowWelcome] = useState(true);
    const [greeting, setGreeting] = useState('');
    
    // Correctly calculate current hour in Pakistan Standard Time (UTC+5)
    const currentHour = new Date().getHours(); // Automatically gets user's system time

    useEffect(() => {
        setTimeout(() => {
            setShowWelcome(false);
        }, 3000); // Show "Welcome User" for 3 seconds

        const iconStyle = {
            fontSize: "3rem",
            color: currentHour >= 5 && currentHour < 18 ? "#FFA500" : "#4A90E2", // Orange for morning/afternoon, blue for evening
            marginLeft: "15px",
            backgroundColor: "rgba(255, 255, 255, 0.25)",
            padding: "5px",
            borderRadius: "50%",
            boxShadow: `0 6px 12px rgba(0, 0, 0, 0.2), 0 8px 24px ${
                currentHour >= 5 && currentHour < 18 ? "rgba(255, 165, 0, 0.5)" : "rgba(74, 144, 226, 0.5)"
            }`,
            backdropFilter: "blur(10px)",
        };

        // Adjust greetings based on the specified time ranges
        if (currentHour >= 5 && currentHour < 12) {
            setGreeting(
                <span style={{ display: "flex", alignItems: "center", fontSize: "1.4rem", marginLeft: "20px", color: "#fff" }}>
                    Good Morning <FaSun style={iconStyle} />
                </span>
            );
        } else if (currentHour >= 12 && currentHour < 18) {
            setGreeting(
                <span style={{ display: "flex", alignItems: "center", fontSize: "1.4rem", marginLeft: "20px", color: "#fff" }}>
                    Good Afternoon <FaSun style={iconStyle} />
                </span>
            );
        } else {
            setGreeting(
                <span style={{ display: "flex", alignItems: "center", fontSize: "1.4rem", marginLeft: "20px", color: "#fff" }}>
                    Good Evening <FaMoon style={{ ...iconStyle, color: "#4A90E2" }} />
                </span>
            );
        }
    }, [currentHour]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        const contentElement = document.querySelector('.content');
        if (contentElement) {
            contentElement.style.marginLeft = sidebarOpen ? '0px' : '250px';
        }
    }, [sidebarOpen]);

    const handleDropdownClick = (e) => {
        e.stopPropagation();
    };

    const closeDropdown = (e) => {
        const dropdown = e.target.closest('.dropdown');
        if (dropdown) {
            dropdown.classList.remove('show');
            const menu = dropdown.querySelector('.dropdown-menu');
            if (menu) menu.classList.remove('show');
        }
    };

    const logOut = async (event) => {
        event.preventDefault();
        secureLocalStorage.clear();
        userActions.logOut(null);
        window.location.href = '/';
    };

    return (
        <>
          <div className={`sidebar pe-4 pb-3 glass-effect ${sidebarOpen ? 'open' : ''}`}>
    <nav className="navbar glass-effect bg-light navbar-light">
        {/* Logo and Profile Section */}
        <Link to="/dashboard" className="navbar-brand mb-3" style={{marginLeft: "14px"}}>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                {/* Option 1: Use your custom logo image */}
                <img src={logoIcon} style={{ width: "180px", marginBottom: "10px" }} alt="Medical Center Logo" />
                
                {/* Option 2: Or use a text-based logo with medical icon */}
                {/* <div style={{ display: "flex", alignItems: "center", color: "#2c5aa0", fontWeight: "bold", fontSize: "1.5rem" }}>
                    <FaStethoscope style={{ marginRight: "10px", color: "#2c5aa0" }} />
                    HEALTH CARE
                </div>
                <div style={{ color: "#666", fontSize: "0.9rem", marginTop: "5px" }}>
                    Medical Center
                </div> */}
            </div>
        </Link>
        
        {/* Profile Image */}
        <div className="d-flex align-items-center ms-4 mb-4">
            <div className="position-relative">
                <img className="rounded-circle glass-avatar" src={avatarIcon} alt="" style={{ width: "50px", height: "50px" }} />
                <div className="status-indicator bg-success rounded-circle border border-2 border-white position-absolute end-0 bottom-0 p-1"></div>
            </div>
            <div className="ms-3">
                <h6 className="mb-0">AZM</h6>
                <span className="admin">Admin</span>
            </div>
        </div>
        
        {/* Navigation Links */}
        <div className="navbar-nav w-100">
            <Link to="/dashboard" className="nav-item nav-link active">
                <i className="fa fa-home me-2"></i>Dashboard
            </Link>

            <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="fa fa-receipt me-2"></i>Receipt
                </a>
                <div className="dropdown-menu bg-transparent border-0" onClick={handleDropdownClick}>
                    <Link to="/patient-receipt" className="dropdown-item" onClick={closeDropdown}>
                        📋 Patient Receipt
                    </Link>
                    <Link to="/patient-receipt-list" className="dropdown-item" onClick={closeDropdown}>
                        📋 Receipt List
                    </Link>
                </div>
            </div>
            
            <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="fa fa-ticket-alt me-2"></i>Tokens
                </a>
                <div className="dropdown-menu bg-transparent border-0" onClick={handleDropdownClick}>
                    <Link to="/token-calling" className="dropdown-item" onClick={closeDropdown}>
                        📋 Token Calling
                    </Link>
                </div>
            </div>
            
            <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="fa fa-calendar-check me-2"></i>Appointment
                </a>
                <div className="dropdown-menu bg-transparent border-0" onClick={handleDropdownClick}>
                    <Link to="/view-appointment" className="dropdown-item" onClick={closeDropdown}>
                        📋 Appointment List
                    </Link>
                </div>
            </div>
            
            <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="fa fa-user-md me-2"></i>Doctors
                </a>
                <div className="dropdown-menu bg-transparent border-0" onClick={handleDropdownClick}>
                    <Link to="/add-doctor" className="dropdown-item" onClick={closeDropdown}>
                        ➕ Add Doctors
                    </Link>
                    <Link to="/doctors-list" className="dropdown-item" onClick={closeDropdown}>
                        📋 Doctors List
                    </Link>
                </div>
            </div>

            <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="fa fa-users me-2"></i>Staff
                </a>
                <div className="dropdown-menu bg-transparent border-0" onClick={handleDropdownClick}>
                    <Link to="/add-staff" className="dropdown-item" onClick={closeDropdown}>
                        🏷 Add Staff
                    </Link>
                    <Link to="/view-staff" className="dropdown-item" onClick={closeDropdown}>
                        👥 Staff List
                    </Link>
                </div>
            </div>
            
            <div className="nav-item dropdown">
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="fa fa-clock me-2"></i>Hours
                </a>
                <div className="dropdown-menu bg-transparent border-0" onClick={handleDropdownClick}>
                    <Link to="/add-hour" className="dropdown-item" onClick={closeDropdown}>
                        ➕ Add Hours
                    </Link>
                    <Link to="/view-hour" className="dropdown-item" onClick={closeDropdown}>
                        📋 Hours List
                    </Link>
                </div>
            </div>
        </div>
    </nav>
</div>

<nav className="navbar navbar-expand bg-light navbar-light sticky-top px-4 py-0">
    <Link to="/" className="navbar-brand d-flex d-lg-none me-4">
        <h2 className="text-primary mb-0">
            <img src={favIcon} style={{ width: "50px" }} alt="Medical Center Icon" />
        </h2>
    </Link>
    <a href="#" className="sidebar-toggler flex-shrink-0" onClick={toggleSidebar}>
        <i className="fa fa-bars"></i>
    </a>
    <h2
        className="greeting-text"
        style={{
            fontSize: "20px",
            color: "#333",
            fontWeight: "500",
            animation: showWelcome ? "fadeInOut 3s ease-in-out" : "none",
        }}
    >
        {showWelcome ? (
            <span style={{ display: "flex", alignItems: "center", fontSize: "1.2rem", marginLeft: "10px", color: "#fff" }}>
                Welcome Admin
                <FaHandPaper
                    style={{
                        fontSize: "3rem",
                        marginLeft: "10px",
                        padding: "5px",
                        animation: "wave 1s infinite",
                        color: "rgb(226 205 4)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundColor: "rgba(255, 255, 255, 0.25)",
                        boxShadow: `0 6px 12px rgba(255, 255, 0, 0.3), 0 8px 24px ${
                            currentHour < 18 ? "rgba(255, 223, 0, 0.5)" : "rgba(255, 165, 0, 0.5)"
                        }`,
                        borderRadius: "50%",
                        backdropFilter: "blur(10px)",
                    }}
                />
            </span>
        ) : (
            greeting
        )}
    </h2>
    <div className="navbar-nav nav-mini align-items-center ms-auto">
        <div className="nav-item dropdown">
            <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" style={{color: "#fff"}}>
                <img className="rounded-circle me-lg-2" src={avatarIcon} alt="Avatar"
                     style={{ width: "50px", height: "50px" }} />
                <span className="d-none d-lg-inline-flex">AZM</span>
            </a>
            <div className="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                <Link to="#" onClick={(e) => { logOut(e); }} className="dropdown-item">Log Out</Link>
            </div>
        </div>
    </div>
</nav>
        </>
    );
}